import { useCallback } from 'react';
import { buildApiUrl } from '../api';
import { useAuthAccess } from './AuthAccessProvider';

export function useApiClient() {
  const { getAccessToken } = useAuthAccess();

  const request = useCallback(async (path, options = {}) => {
    let token;
    try {
      token = await getAccessToken();
    } catch (error) {
      throw error;
    }

    const headers = new Headers(options.headers || {});
    headers.set('Authorization', `Bearer ${token}`);

    const response = await fetch(buildApiUrl(path), {
      ...options,
      headers
    });

    if (response.status === 401) {
      const error = new Error('The backend rejected the current Microsoft access token. Please ask IT to check the backend issuer, audience, and app-role validation settings.');
      error.code = 'api_authentication_required';
      error.status = response.status;
      throw error;
    }

    if (response.status === 403) {
      const error = new Error('The backend accepted the Microsoft token, but your account does not have the required ExecEye role.');
      error.code = 'api_insufficient_permissions';
      error.status = response.status;
      throw error;
    }

    return response;
  }, [getAccessToken]);

  return { request };
}
